export const constants = {
  defaultCurrency: "JPY",
};
